import { render, staticRenderFns } from "./CompanyProjectDetail.vue?vue&type=template&id=2542b844&"
import script from "./CompanyProjectDetail.vue?vue&type=script&lang=js&"
export * from "./CompanyProjectDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports